define('common/createCookieAccessor',[
    'jquery',
    'knockout',
    'underscore',
    'base64',
    'jquery.cookie'
], function($, ko, _, base64, cookie) {

    /**
     * Initialise areCookiesEnabled by trying to write a cookie
     */
    try {
        cookie('cookieAccessorsTest', 'enabled', { path: '/' });
        createCookieAccessor.areCookiesEnabled = cookie('cookieAccessorsTest') === 'enabled';
        cookie('cookieAccessorsTest', '', { path: '/', expires: -1 });
    } catch (e) {
        createCookieAccessor.areCookiesEnabled = false;
    }

    /**
     * Creates an observable interface to a cookie.
     *
     * @param {common/Logger} LOG
     * @param {String} cookieName
     * @param {Number} daysUntilExpiry
     *
     * @throws {Error} When cookies are not enabled
     *
     * @return {Observable}
     */
    function createCookieAccessor(LOG, cookieName, daysUntilExpiry) {

        var cookieAccessor,
            innerStore = ko.observable(),
            initialCookieValue;

        if (createCookieAccessor.areCookiesEnabled) {

            try {

                initialCookieValue = cookie(cookieName);

                if (initialCookieValue) {
                    innerStore( decode(initialCookieValue) );
                }

            } catch (e) {
                e.message = 'Malformed cookie "' + cookieName + '".\nMessage: ' + e.message + '\nData: ' + document.cookie;
                LOG.error(e);
            }

            cookieAccessor = ko.pureComputed({
                read: innerStore,
                write: function(value) {

                    var encodedValue;

                    try {
                        encodedValue = base64.encode(JSON.stringify(value)).replace(/=/g, '-');
                    } catch (e) {
                        e.message = 'Error encoding cookie.\nMessage: ' + e.message;
                        LOG.error(e);
                        return;
                    }

                    cookie(
                        cookieName,
                        encodedValue,
                        {
                            raw: true,
                            path: '/',
                            expires: daysUntilExpiry,
                            secure: window.location.protocol === 'https:'
                        }
                    );

                    // Decode to ensure the value now will be the same as when its loaded in the future
                    innerStore( decode(encodedValue) );
                }
            });

        } else {

            cookieAccessor = innerStore;

        }

        /**
         * Use this to treat a cookie like a key value store and write to a single key with an observable interface
         *
         * @param {String} key
         *
         * @return {Observable}
         */
        cookieAccessor.createKeyValueCookieAccessor = function(key) {

            if (!cookieAccessor()) {
                cookieAccessor({});
            }

            return ko.pureComputed({
                read: function() {
                    return cookieAccessor()[key];
                },
                write: function(value) {
                    var data = $.extend(true, {}, cookieAccessor());
                    data[key] = value;
                    cookieAccessor(data);
                }
            });

        };

        return cookieAccessor;

        function decode(value) {

            var json;

            try {
                json = base64.decode( value.replace(/-/g, '=') );
                return JSON.parse(json);
            } catch (e) {
                e.message = 'Error decoding cookie.\nMessage: ' + e.message + '\nData: ' + json;
                LOG.error(e);
            }
        }

    }

    return createCookieAccessor;

});

